
const extents = {
    "pw":[0.25,4.0]
}

const colors = {
    "pw":[
        '#ffdc2e', //0.25
        '#f5cc00', //0.5
        '#dba100', //0.75
        '#d66f00', //1.0
        '#bd2c00', //1.5
        '#8f1d00', //2.0
        '#9f05ff', //3.0
        '#d3d3d3', //4.0
    ]
}

const values = {
    "pw":[0.25,0.5,0.75,1.0,1.5,2.0,3.0,4.0]
}

function createTexture(layertype) {

    //get values
    const color=colors[layertype];
    const levs=values[layertype];
    
    //create canvas element
    const colortcanvas = document.createElement("CANVAS");
    
    colortcanvas.width=1200;
    colortcanvas.height=1;
    const ctxt = colortcanvas.getContext('2d');
    ctxt.clearRect(0,0,colortcanvas.width,colortcanvas.height); 
    const grdt=ctxt.createLinearGradient(0,0,1200,0);
    
    const cmax=extents[layertype][1];
    const cmin=extents[layertype][0];
    const clen=color.length;

    for (let i=0;i<clen;++i) {
        grdt.addColorStop((levs[i]-cmin)/(cmax-cmin),color[i]);
    }

    ctxt.fillStyle=grdt;
    ctxt.fillRect(0,0,1200,1);

    const imageData=ctxt.getImageData(0,0,1200,1);

    return {
        imageData: imageData,
    }
}

export { createTexture }